import { render, staticRenderFns } from "./ModalProductPromo.vue?vue&type=template&id=76a70713&scoped=true&"
import script from "./ModalProductPromo.vue?vue&type=script&lang=js&"
export * from "./ModalProductPromo.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductPromo.vue?vue&type=style&index=0&id=76a70713&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a70713",
  null
  
)

export default component.exports